import { render, staticRenderFns } from "./singleDialog.vue?vue&type=template&id=6bfce9ef"
import script from "./singleDialog.vue?vue&type=script&lang=js"
export * from "./singleDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports